import React, { useState } from "react";
import { useMutation } from "react-query";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Row, Col, Select } from "antd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import RangePickerComp from "../../../../../components/common/RangePickerComp";
import SwitchComp from "../../../../../components/common/SwitchComp";
import UploadFormItem from "../UploadFormItem";
import dayjs from "dayjs";
import moment from "moment";
import Treeselect from "../../../../../components/common/Treeselect";

const initialState = {
  check: false,
  desktopImageFile: null,
  desktopImageUrl: null,
  mobileImageFile: null,
  mobileImageUrl: null,
  destinationUrl: null,
  id: null,
};

const ModalNewCategoryBanner = ({
  onClose,
  modalOpt,
  orderShops,
  bigBoxCategory,
  bannerData,
}) => {
  const [form] = Form.useForm();
  const [switches, setSwitches] = React.useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [processedCategoryOptions, setProcessedCategoryOptions] = useState([]);
  const [bannerType, setBannerType] = useState('carousel');

  const convertToTreeData = (treeData) => {
    if (!treeData || !Array.isArray(treeData)) return [];

    const modifyParentNodes = (node) => {
      if (node.children && node.children.length > 0) {
        const parentAsChild = {
          name: `${node.name}`,
          value: node.value,
          id: node.id,
          isParentCopy: true
        };

        const realId = node.value;
        node.value = `00_${realId}`;

        node.children.unshift(parentAsChild);

        for (let i = 1; i < node.children.length; i++) {
          modifyParentNodes(node.children[i]);
        }
      }

      return node;
    };

    return treeData.map(modifyParentNodes);
  };

  React.useEffect(() => {
    if (bigBoxCategory) {
      const processed = convertToTreeData(bigBoxCategory);
      setProcessedCategoryOptions(processed);
    }
  }, [bigBoxCategory]);

  const hasRun = React.useRef(false);

  React.useEffect(() => {
    if (!hasRun.current) {
      const initialSwitches = {};
      orderShops.forEach((shop) => {
        initialSwitches[shop.label.replace(" ", "")] = {
          ...initialState,
          id: shop.value,
        };
      });
      setSwitches(initialSwitches);
      hasRun.current = true;
    }
  }, [orderShops]);


  const mutation = useMutation({
    mutationFn: (value) => {
      const formData = new FormData();
      formData.append("banner[title]", value.title);
      formData.append("banner[custom_event]", value.custom_event);
      formData.append("banner[sort_order]", value.sort_order);
      formData.append("banner[banner_type]", value.banner_type || "carousel");
      value.category.forEach((categoryId) => {
        formData.append("banner[categories][]", categoryId);
      });
      formData.append("banner[banner_place]", "category");
      formData.append("banner[valid_from]", value.validity_period[0]);
      formData.append("banner[valid_to]", value.validity_period[1]);

      Object.entries(switches).forEach(([key, switchData], index) => {
        console.log(switchData, "switchData");
        if (switchData.destinationUrl === null) {
          return;
        }
        const desktopFile = switchData?.desktopImageFile;
        const mobileFile = switchData?.mobileImageFile;
        if (desktopFile) {
          formData.append(
            `banner[banner_shops_attributes][${index}][desktop_file][data]`,
            desktopFile
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][desktop_file][title]`,
            desktopFile.name
          );
        }

        if (mobileFile) {
          formData.append(
            `banner[banner_shops_attributes][${index}][mobile_file][data]`,
            mobileFile
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][mobile_file][title]`,
            mobileFile.name
          );
        }

        formData.append(
          `banner[banner_shops_attributes][${index}][destination_url][]`,
          switchData.destinationUrl
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][active]`,
          switchData.check ? "true" : "false"
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][order_shop_id]`,
          switchData.id
        );
        if (modalOpt.type === "edit_category_banner") {
          if (switchData.banner_shop_id) {
            formData.append(
              `banner[banner_shops_attributes][${index}][id]`,
              switchData.banner_shop_id
            );
          }
        }
      });

      return Axios[modalOpt.type === "edit_category_banner" ? "put" : "post"](
        `/api/v1/banners/${modalOpt.type === "edit_category_banner" ? modalOpt.record_id : ""
        }`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      ).then((res) => res.data);
    },
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const handleFileChange = (name, type, file, url) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}ImageFile`]: file,
        [`${type}ImageUrl`]: url,
        [`${type}Image`]: file,
        [`${type}ImageFileTitle`]: file?.name,
      },
    }));
  };

  const handleSwitchChange = (name) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        check: !prev[name].check,
      },
    }));
  };

  const handleInputChange = (name, type, value) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}`]: value,
      },
    }));
  };

  React.useEffect(() => {
    if (modalOpt.type === "edit_category_banner") {
      const matchingBanner = bannerData.find(
        (banner) => banner.id === modalOpt.record_id
      );
      console.log(matchingBanner, "matchingBanner");
      if (matchingBanner) {
        form.setFieldsValue({
          title: matchingBanner.title,
          custom_event: matchingBanner.custom_event,
          sort_order: matchingBanner.sort_order,
          banner_type: matchingBanner.banner_type || "carousel",
          validity_period: [
            moment(matchingBanner.valid_from),
            moment(matchingBanner.valid_to),
          ],
          category: matchingBanner.categories.map((category) => category.id),
        });
        setBannerType(matchingBanner.banner_type || "carousel");

        matchingBanner.banner_shops.forEach((shop) => {
          const switchName = shop.order_shop.title?.replace(" ", "");
          console.log(switches, "switches");
          console.log(switches[switchName], "switches[switchName]");
          setSwitches((prev) => {
            if (prev[switchName]) {
              return {
                ...prev,
                [switchName]: {
                  ...prev[switchName],
                  desktopImageUrl: shop.desktop_image,
                  mobileImageUrl: shop.mobile_image,
                  destinationUrl: shop.destination_url,
                  check: shop.active,
                  originalCheck: shop.active,
                  banner_shop_id: shop.id,
                },
              };
            } else {
              return {
                ...prev,
                [switchName]: {
                  desktopImageUrl: shop.desktop_image,
                  mobileImageUrl: shop.mobile_image,
                  destinationUrl: shop.destination_url,
                  check: shop.active,
                  originalCheck: shop.active,
                  banner_shop_id: shop.id,
                },
              };
            }
          });
          form.setFieldsValue({
            [`destination_url_${switchName}`]: shop.destination_url,
          });
        });
        const categoryIds = matchingBanner.categories.map((category) => category.id);
        setSelectedCategories(categoryIds);
      }
    }
  }, [modalOpt]);

  return (
    <ModalSpecial
      style={{ width: 570 }}
      text={
        <span className="font-bold text-xl text-black">
          {modalOpt.type === "edit_category_banner" ? "Edit" : "Add"} category
          banner
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          const formValues = {
            ...values,
            category: selectedCategories,
          };
          mutation.mutate(formValues);
        }}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Input placeholder="Type in" />
            </Form.Item>
          </Col>


          <Col span={12}>
            <Form.Item
              label="Custom event"
              name="custom_event"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Input placeholder="Type in" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Category"
              name="category"
              rules={[{ required: false, message: "Can't be empty" }]}
            >
              <Treeselect
                options={processedCategoryOptions || []}
                value={selectedCategories}
                onChange={(values) => {
                  const categoryIds = values.map(value => {
                    return typeof value === 'string' && value.startsWith('00_')
                      ? parseInt(value.substring(3))
                      : value;
                  });
                  setSelectedCategories(categoryIds);
                  form.setFieldsValue({ category: categoryIds });
                }}
                placeholder="Select categories..."
                multiSelect={true}
                searchable={true}
                confirmClear={true}
                dropdownWidth="500px"
                showStrategy="SHOW_ALL"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Banner type"
              name="banner_type"
              initialValue="carousel"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Select
                placeholder="Select banner type"
                onChange={(value) => setBannerType(value)}
              >
                <Select.Option value="carousel">Carousel</Select.Option>
                <Select.Option value="product_grid">Product Grid</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={bannerType === 'carousel' ? 'Order in carousel' : 'Order in grid'} name="sort_order">
              <Input placeholder="Type in" type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Validity period"
          name="validity_period"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <RangePickerComp
            style={{ width: "100%" }}
            showTime={{ format: "HH:mm" }}
            placeholder={["Start time", "End time"]}
            disabledDate={() => false}
          />
        </Form.Item>
        <hr className="hr-margin" />
        {Object.keys(switches).map((switchName) => (
          <div key={switchName}>
            <SwitchComp
              className="d-flex flex-row-reverse justify-content-end"
              labelClassName="ml-1"
              label={switchName.slice(0, 2) + " " + switchName.slice(2)}
              checked={switches[switchName].check}
              onChange={() => handleSwitchChange(switchName)}
            />
            {switches[switchName].check && (
              <div>
                <Row gutter={16}>
                  <Col span={12}>
                    <UploadFormItem
                      name={switchName}
                      label="Desktop image"
                      requiredMessage="Please upload an image!"
                      greyText={bannerType === 'product_grid' ? "Recommended .jpeg, .png format and 250x620" : "Recommended .jpeg, .png format and 1200x644"}
                      onFileChange={(file, url) =>
                        handleFileChange(switchName, "desktop", file, url)
                      }
                      externalURL={switches[switchName].desktopImageUrl}
                    />
                  </Col>
                  <Col span={12}>
                    <UploadFormItem
                      name={switchName}
                      label="Mobile image"
                      requiredMessage="Please upload an image!"
                      greyText="Recommended .jpeg, .png format and 360x555"
                      onFileChange={(file, url) =>
                        handleFileChange(switchName, "mobile", file, url)
                      }
                      externalURL={switches[switchName].mobileImageUrl}
                    />
                  </Col>
                </Row>
                <Form.Item
                  label="Destination URL"
                  name={`destination_url_${switchName}`}
                  rules={[
                    { required: true, message: "Can't be empty" },
                    () => ({
                      validator(_, value) {
                        const urlPattern = new RegExp(
                          "^(https?:\\/\\/)?" + // protocol
                          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
                          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                          "(\\#[-a-z\\d_]*)?$",
                          "i"
                        ); // fragment locator
                        if (!value || urlPattern.test(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Please enter a valid URL")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="Type in"
                    onChange={(e) =>
                      handleInputChange(
                        switchName,
                        "destinationUrl",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>
              </div>
            )}
            <hr className="hr-margin" />
          </div>
        ))}
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutation.isLoading}
          >
            {modalOpt.type === "edit_category_banner" ? "Update" : "Add"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default ModalNewCategoryBanner;
